import { Link } from '@tanstack/react-router';
import { Download, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollReveal } from '@/components/common/ScrollReveal';

/**
 * HeroSection
 * 感情的ストーリーテリング型のHero
 * 左寄せテキスト + 右側ヒーロー画像（斜めグラデーションフェード）
 */
export function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col lg:flex-row items-center px-6 md:px-16 lg:px-24 max-w-7xl mx-auto bg-background gap-12 py-24 lg:py-0">
      {/* Text */}
      <div className="flex-1 flex flex-col justify-center">
        <ScrollReveal direction="up" delay={0}>
          <div className="text-[13px] font-semibold text-accent uppercase tracking-wider mb-6">
            Omokage
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.1}>
          <h1 className="text-6xl md:text-7xl font-bold tracking-tight leading-[1.05] mb-8">
            あの日の思い出を、
            <br />
            <span className="text-accent">もう一度。</span>
          </h1>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.2}>
          <p className="text-xl text-muted-foreground max-w-xl leading-relaxed mb-12">
            VRChatで撮った何千枚もの写真。ワールド名も、一緒にいた人も、自動で記録。デスクトップアプリがすべてを整理し、クラウドに同期します。
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.3}>
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <Button asChild size="lg" className="gap-2">
              <Link to="/download">
                <Download className="w-4 h-4" />
                ダウンロード (Windows)
              </Link>
            </Button>
            <Button asChild variant="ghost" size="lg">
              <Link to="/login">Webで始める</Link>
            </Button>
          </div>
          <p className="text-sm text-muted-foreground">無料 &middot; Windows 10/11</p>
        </ScrollReveal>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-muted-foreground/40">
        <ChevronDown className="w-5 h-5" />
      </div>

      {/* Hero image */}
      <ScrollReveal direction="up" delay={0.2} className="flex-[2] w-full">
        <img
          src="/images/hero.jpg"
          alt="VRChat photo example"
          className="w-full h-auto object-cover"
          style={{
            maskImage:
              'linear-gradient(to top right, transparent 0%, black 35%, black 65%, transparent 100%)',
            WebkitMaskImage:
              'linear-gradient(to top right, transparent 0%, black 35%, black 65%, transparent 100%)',
          }}
        />
      </ScrollReveal>
    </section>
  );
}
